module.exports = "currency: {{transactionCurrency}},\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionCurrency.html
// module id = 2155
// module chunks = 0